import dayjs from 'dayjs';

let util = {};


util.formatDate = (date, format = 'YYYY-MM-DD') => {
    return dayjs(date).format(format);
};

// 深拷贝
util.deepClone = (obj) => {
    // var target = {};
    // for(var key in obj) {
    //     if (Object.prototype.hasOwnProperty.call(obj, key)) {
    //         if (typeof obj[key] === 'object') {
    //             target[key] = deepClone(obj[key]);
    //         } else {
    //             target[key] = obj[key];
    //         }
    //     }
    // }
    // return target;
    let tmp = JSON.stringify(obj);
    return JSON.parse(tmp);
};

//数组去重
util.unique = (arr)=>{
    const res = new Map();
    return arr.filter((a) => !res.has(a) && res.set(a, 1))
};

//导出文件
util.exportFile = function ( path ) {
    console.log('exportFile',path);
    // return window.open( path , "_blank" );
    try{
        let elemIF = document.createElement("iframe");
        elemIF.src = path;
        elemIF.style.display = "none";
        document.body.appendChild(elemIF);
        setTimeout(()=>{
            elemIF.remove();
        },1000*30)
    }catch(e){
        console.log('exportFile error',e);
    }
};

util.setClipboardText = (value)=>{
    const text = document.createElement('textarea');
    text.value = value;
    document.body.appendChild(text);
    text.select();
    document.execCommand('Copy');
    text.remove();
};

util.getVideoScaleHCF = (width,height)=>{
    let n1,n2;
    if (width > height) {
        n1 = width;
        n2 = height;
    } else {
        n1 = height;
        n2 = width;
    }

    let remainder = n1 % n2;
    if (remainder === 0) {
        return n2;
    } else {
        return util.getVideoScaleHCF(n2, remainder)
    }

};

util.randomString = (length) =>{
    length = length||10;
    let str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    for (let i = length; i > 0; --i)
        result += str[Math.floor(Math.random() * str.length)];
    return result;
};

// 秒数格式化
util.secondToDuration = (second,lang) => {

    let s = '秒';
    let h = '小时';
    let m = '分钟';

    if(lang&&lang=='en'){
        s = 's ';
        h = 'h ';
        m = 'm ';
    }




    if(second===0||second==='0') return ('0'+s);
    if(!second||isNaN(second)) return '--';
    second = +second;
    let hours = parseInt(second/3600);
    let seconds = parseInt((second%3600)%60) ;
    let minutes = parseInt((second%3600)/60);
    let hoursText = hours>0?hours+h:'';
    let minutesText = minutes>0?minutes+m:'';
    let secondsText = seconds>0?seconds+s:'';
    return hoursText+minutesText+secondsText;
};

// 将对象转为url参数形式，如val=114&val2=222
util.toUrlParams = (param)=>{
    return Object.keys(param).map(key => `${key}=${param[key]}`).join('&');
};

// 文件大小B格式化为KB、MB、GB
util.formatFileSize = (fileSize)=>{
    if (fileSize < 1024) {
        return fileSize + 'B';
    } else if (fileSize < (1024*1024)) {
        let temp = fileSize / 1024;
        temp = temp.toFixed(2);
        return temp + 'KB';
    } else if (fileSize < (1024*1024*1024)) {
        let temp = fileSize / (1024*1024);
        temp = temp.toFixed(2);
        return temp + 'MB';
    } else {
        let temp = fileSize / (1024*1024*1024);
        temp = temp.toFixed(2);
        return temp + 'GB';
    }
};

function _getObjectDepth(obj,prop) {
    let result = 0;
    if (obj && typeof obj === 'object') {
        if(obj[prop]){
            let children = obj[prop];
            let childDeep = 0;
            if(Array.isArray(children)&&children.length>0){
                result++;
                childDeep = Math.max(...children.map(item=>_getObjectDepth(item,prop)));
                result = result+childDeep;
            }
            return result
        }
        return result;
    }
    return result;
}

util.getArrayDepth = (array,prop)=>{
    if(array.length<=0) return 0;
    return Math.max(...array.map(item=>_getObjectDepth(item,prop)))+1;
};

util.getArraySum = (arr)=>{
    let result = 0;
    arr.forEach(item=>{
        result+=item;
    });
    return result;
};


export default util;
